import { useCallback } from 'react'
import { CellTitle, CellValueArea, FormCell, CellPropsBase } from '.'
import { DateInput } from '../../../../components/inputs/DatePicker'
import { DateV2 } from '../../../../../domain/value-object/DateV2'

type DateCellProps = {
  value: DateV2 | undefined
  onChange?: (v: DateV2 | undefined) => void
} & CellPropsBase

export const DateCell = ({
  value,
  onChange: _onChange,
  cellWidth,
  label,
  editable = true,
  required = false,
  edited,
  validationErrors,
}: DateCellProps) => {
  const onChange = useCallback(
    (v: Date | undefined) => {
      _onChange && _onChange(v)
    },
    [_onChange]
  )
  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <DateInput editable={editable} value={value} onChange={onChange} />
      </CellValueArea>
    </FormCell>
  )
}
